import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "sales-proposals-and-contracts"
    }}>{`Sales Proposals and Contracts`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Sales proposals set the tone for customer relationships. As they are often one of the first touchpoints a company has with a prospect, information included must be accurate, complete, and presented in a polished, brand-consistent manner. However, creating a sales proposal is a tedious and cumbersome process of mixing standard and deal-specific custom content, all of which takes valuable time away from actually selling.`}</p>
    <p>{`Using Adobe Acrobat Services, sales teams can:`}</p>
    <ul>
      <li parentName="ul">{`Design sales proposal and contract templates in Microsoft Word and merge data from CRM and other data systems`}</li>
      <li parentName="ul">{`Create custom, on-brand PDF proposals and contracts`}</li>
      <li parentName="ul">{`Include the ability for customers to electronically sign documents`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.io/apis/documentcloud/sign.html"
        }}>{`Adobe Acrobat Sign API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A business development team meets frequently with prospects. Shortly after, they follow up with sales proposals. While much proposal content is reusable—firm capabilities, team profiles, SOW terms, etc.—important deal specifics, such as customer information, project scope, and pricing needs to be added. Manually finding and replacing content, as well as highlighting signature fields, is time consuming and monotonous. Automation is needed to ensure accuracy and to deliver proposals quickly.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create a simple data capture form using Microsoft Form (or another form builder)`}</li>
      <li parentName="ol">{`Design the sales proposal and contract template using Microsoft Word`}</li>
      <li parentName="ol">{`Use Adobe Document Generation Tagger in Word to place fields into the template based on the data model from the form`}</li>
      <li parentName="ol">{`Run the Adobe Document Generation API to merge data from the form into the template, creating a final proposal and contract in PDF`}</li>
      <li parentName="ol">{`Send to Adobe Acrobat Sign if signatures are required, and if not, to email directly`}</li>
    </ol>
    <h3 {...{
      "id": "enhancements"
    }}>{`Enhancements`}</h3>
    <p>{`The Adobe PDF Services API can programmatically compress and add password protection to a PDF before sending.`}</p>
    <h3 {...{
      "id": "building-in-power-automate"
    }}>{`Building in Power Automate`}</h3>
    <p>{`A solution to this use-case can also be implemented in Power Automate by using the following Adobe connectors:`}</p>
    <ul>
      <li parentName="ul">{`Adobe PDF Services Connector (includes Document Generation)`}</li>
      <li parentName="ul">{`Adobe Acrobat Sign Connector`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      